import { z } from "zod";
export const ProStatus = z.strictObject({
  active: z.boolean(),
  planCode: z.string().nullable(),
  expiresAt: z.iso.datetime().nullable(),
});
export type ProStatus = z.infer<typeof ProStatus>;
export const FREE_STATUS: ProStatus = { active: false, planCode: null, expiresAt: null };
export const RedeemInput = z.strictObject({ code: z.string().trim().min(1).max(80) });
export const FEATURE_KEYS = [
  "pro",
  "notes",
  "practice_levels",
  "remedy",
  "p7_explanations",
  "dictation",
  "vocab_topics",
  "collocations",
  "paraphrase",
  "vocab_b2",
] as const;
export const FeatureKey = z.enum(FEATURE_KEYS);
export type FeatureKey = z.infer<typeof FeatureKey>;
export const Plan = z.strictObject({
  code: z.string(),
  name: z.string(),
  durationDays: z.number().int().positive().nullable(),
  priceVnd: z.number().int().nonnegative(),
  listPriceVnd: z.number().nullable(),
  badge: z.string().nullable(),
  note: z.string().nullable(),
});
export const Comparison = z.strictObject({
  rows: z.array(z.strictObject({ label: z.string(), free: z.string(), pro: z.string() })),
  totals: z.record(z.string(), z.number()),
  faq: z.array(z.strictObject({ question: z.string(), answer: z.string() })),
});
export const Upsell = z.strictObject({
  gate: FeatureKey,
  title: z.string(),
  message: z.string(),
  counts: z.record(z.string(), z.number()),
  href: z.literal("/pro"),
});
export type Upsell = z.infer<typeof Upsell>;
